export default "__VITE_ASSET__CkfyI0Kl__"